import getBasePath from '../functions/api-resource';

const basePath = getBasePath('orcamento', 'orcamento');

const orcamentoActions = {
  salvar: { method: 'POST', url: `${basePath}/cadastro` },
  atualizar: { method: 'PUT', url: `${basePath}/cadastro` },
  concluir: { method: 'PUT', url: `${basePath}/conclusao/{idOrcamento}` },
  cancelar: { method: 'PUT', url: `${basePath}/cadastro/{idOrcamento}/cancelar` },
  executarAnalise: { method: 'PUT', url: `${basePath}/cadastro/{idOrcamento}/analise` },
};

export default (resource) => resource(`${basePath}`, {}, orcamentoActions);
